import { AxiosResponse } from 'axios';
import api from './Api'

export const updateFcmToken = (tokens: IUpdateFcmToken) => {
    return api.put(`/mobile/fcm/tokens`, tokens);
}

export const getMemberDataByToken = (): Promise<AxiosResponse<IMember, any>> => {
    return api.get(`/mobile/member/token`);
}

export const getMemberCouponPointTicket = (): Promise<AxiosResponse<IMemberPointCouponForResign, any>> => {
    return api.get(`/mobile/member/resign/token`);
}

export const getMemberByMemberId = (): Promise<AxiosResponse<MemberMyWebResponseV2>> => {
    return api.get(`/member/my/web/v2`);
}

export const getResignDataByMemberId = (): Promise<AxiosResponse<IMemberMyResignWebResponseV2>> => {
    return api.get(`/member/my/resign/web/v2`);
}

export const getMyReservationHistory = (): Promise<AxiosResponse<Array<IGetMyReservationHistoryResponse>>> => {
    return api.get(`/member/my/reservation/history`);
}

export const getBasicMemberByToken = () => {
    return api.get<IBasicMember>(`/member/token`);
}
